import React from "react";
import { Link, useLocation } from "react-router-dom";

const MenuItems = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const isActive = (path) => pathname === path;
  const handleclick = () => {
    window.scroll(0, 0);
  };
  return (
    <>
      <li className={isActive("/") ? "current-menu-item" : ""}>
        <Link
          to="/"
          className={isActive("/") ? "active-menu" : ""}
          onClick={handleclick}
        >
          Home
        </Link>
      </li>

      <li className={isActive("/about") ? "current-menu-item" : ""}>
        <Link
          to="/about"
          className={isActive("/about") ? "active-menu" : ""}
          onClick={handleclick}
        >
          About Us
        </Link>
      </li>

      <li
        className={
          pathname.startsWith("/service")
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link
          to="/service"
          className={isActive("/service") ? "active-menu" : ""}
          onClick={handleclick}
        >
          Services
        </Link>
      </li>

      <li
        className={
          pathname.includes("blog")
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <a
          href="https://blog.techniajz.com/blogs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Blog
        </a>
      </li>

      <li className={isActive("/contact") ? "current-menu-item" : ""}>
        <Link
          to="/contact"
          className={isActive("/contact") ? "active-menu" : ""}
          onClick={handleclick}
        >
          Contact Us
        </Link>
      </li>
    </>
  );
};

export default MenuItems;

// import React from "react";
// import { Link } from "react-router-dom";

// const MenuItems = (props) => {
//   const { parentMenu, secondParentMenu, activeMenu } = props;

//   return (
//     <React.Fragment>
//       <li
//         className={
//           parentMenu === "home"
//             ? "menu-item-has-children current-menu-item"
//             : "menu-item-has-children"
//         }
//       >
//         <Link to="/" as="/">
//           Home
//         </Link>
//
//       </li>
//       <li className={parentMenu === "about" ? "current-menu-item" : ""}>
//         <Link
//           to="/about"
//           className={activeMenu === "/about" ? "active-menu" : ""}
//         >
//           About
//         </Link>
//       </li>

//       <li
//         className={
//           parentMenu === "service"
//             ? "menu-item-has-children current-menu-item"
//             : "menu-item-has-children"

//         }
//       >
//         <Link to="/service">
//             Services
//         </Link>
//
//       </li>

//       {/* <li
//         className={
//           parentMenu === "page"
//             ? "menu-item-has-children current-menu-item"
//             : "menu-item-has-children"
//         }
//       >
//         <Link href="#">Pages</Link>
//         <ul className="sub-menu">
//                     <li>
//                         <Link href="#" className={secondParentMenu === 'services' ? 'active-menu' : ''}>Services</Link>
//                         <ul className="sub-menu right ">
//                             <li>
//                                 <Link to="/service/service-1" className={activeMenu === "/service-1" ? "active-menu" : ""}>Service 1</Link>
//                             </li>
//                             <li>
//                                 <Link to="/service/service-2" className={activeMenu === "/service-2" ? "active-menu" : ""}>Service 2</Link>
//                             </li>
//                             <li>
//                                 <Link to="/service/service-3" className={activeMenu === "/service-3" ? "active-menu" : ""}>Service 3</Link>
//                             </li>
//                         </ul>
//                     </li>
//                     <li>
//                         <Link to="/team" className={activeMenu === "/team" ? "active-menu" : ""}>Our Team</Link>
//                     </li>
//                     <li>
//                         <Link to="/team/team-details" className={activeMenu === "/team-details" ? "active-menu" : ""}>Single Team</Link>
//                     </li>
//                     <li>
//                         <Link href="#" className={secondParentMenu === 'case-studies' ? 'active-menu' : ''}>Case Studies</Link>
//                         <ul className="sub-menu right">
//                             <li>
//                                 <Link to="/case-study/style-1" className={activeMenu === "/case-studies-1" ? "active-menu" : ""}>Case Studies Style 1</Link>
//                             </li>
//                             <li>
//                                 <Link to="/case-study/style-2" className={activeMenu === "/case-studies-2" ? "active-menu" : ""}>Case Studies Style 2</Link>
//                             </li>
//                             <li>
//                                 <Link to="/case-study/style-3" className={activeMenu === "/case-studies-3" ? "active-menu" : ""}>Case Studies Style 3</Link>
//                             </li>
//                             <li>
//                                 <Link to="/case-study/style-4" className={activeMenu === "/case-studies-4" ? "active-menu" : ""}>Case Studies Style 4</Link>
//                             </li>
//                             <li>
//                                 <Link to="/case-study/style-5" className={activeMenu === "/case-studies-5" ? "active-menu" : ""}>Case Studies Style 5</Link>
//                             </li>
//                             <li>
//                                 <Link to="/case-study/style-6" className={activeMenu === "/case-studies-6" ? "active-menu" : ""}>Case Studies Style 6</Link>
//                             </li>
//                             <li>
//                                 <Link to="/case-study/style-7" className={activeMenu === "/case-studies-7" ? "active-menu" : ""}>Case Studies Style 7</Link>
//                             </li>
//                         </ul>
//                     </li>
//                     <li>
//                         <Link href="#" className={secondParentMenu === 'shop' ? 'active-menu' : ''}>Shop</Link>
//                         <ul className="sub-menu right">
//                             <li>
//                                 <Link to="/shop" className={activeMenu === "/shop" ? "active-menu" : ""}>Shop</Link>
//                             </li>
//                             <li>
//                                 <Link to="/shop/shop-single" className={activeMenu === "/shop-single" ? "active-menu" : ""}>Shop Single</Link>
//                             </li>
//                             <li>
//                                 <Link to="/shop/cart" className={activeMenu === "/cart" ? "active-menu" : ""}>Cart</Link>
//                             </li>
//                             <li>
//                                 <Link to="/shop/checkout" className={activeMenu === "/checkout" ? "active-menu" : ""}>Checkout</Link>
//                             </li>
//                             <li>
//                                 <Link to="/shop/my-account" className={activeMenu === "/my-account" ? "active-menu" : ""}>My Account</Link>
//                             </li>
//                         </ul>
//                     </li>
//                     <li>
//                         <Link to="/pricing" className={activeMenu === "/pricing" ? "active-menu" : ""}>Pricing</Link>
//                     </li>
//                     <li>
//                         <Link to="/faq" className={activeMenu === "/faq" ? "active-menu" : ""}>Faq</Link>
//                     </li>
//                 </ul>
//       </li> */}

//       <li
//         className={
//           parentMenu === "blog"
//             ? "menu-item-has-children current-menu-item"
//             : "menu-item-has-children"
//         }
//       >
//         <a
//           href="https://blog.techniajz.com/blogs"
//           rel="noopener noreferrer"
//         >
//           Blog
//         </a>
//         {/* <ul className="sub-menu">
//       <li>
//           <Link to="/blog" className={activeMenu === "/blog" ? "active-menu" : ""}>Blog</Link>
//       </li>
//       <li>
//           <Link to="/blog/blog-details" className={activeMenu === "/blog-details" ? "active-menu" : ""}>Blog details</Link>
//       </li>
//   </ul> */}
//       </li>

//       <li className={parentMenu === "contact" ? "current-menu-item" : ""}>
//         <Link
//           to="/contact"
//           className={activeMenu === "/contact" ? "active-menu" : ""}
//         >
//           Contact
//         </Link>
//       </li>
//     </React.Fragment>
//   );
// };

// export default MenuItems;
